// extracted by mini-css-extract-plugin
export var locationCard = "_hj-0";